import type { PromptVisibility } from '../components/Prompts/promptsV2Types';

export type PromptVisibilityMeta = {
  label: string;
  shortDescription: string;
  tooltip: string;
  tone: 'public' | 'recruiters' | 'private';
};

export const PROMPT_VISIBILITY_OPTIONS: PromptVisibility[] = [
  'recruiter_only',
  'public',
  'private',
];

export const PROMPT_VISIBILITY_META: Record<PromptVisibility, PromptVisibilityMeta> = {
  public: {
    label: 'Public View',
    shortDescription: 'Anyone on the internet can view this prompt.',
    tooltip:
      'Anyone with your public profile link can view this screening prompt and its video response.',
    tone: 'public',
  },
  recruiter_only: {
    label: 'Verified Recruiters',
    shortDescription:
      'Only verified recruiters and accounts given full access can view this prompt.',
    tooltip:
      'Only verified recruiters and accounts you have granted full access can view this screening prompt.',
    tone: 'recruiters',
  },
  private: {
    label: 'Private - Only Me',
    shortDescription: 'Only you can view this prompt.',
    tooltip:
      'This screening prompt is hidden from recruiters and public viewers. Only you can see it.',
    tone: 'private',
  },
};

export function resolvePromptVisibility(value?: string | null): PromptVisibility {
  const raw = String(value ?? 'public').toLowerCase();
  if (raw === 'recruiter_only' || raw === 'private') return raw;
  return 'public';
}

export function promptVisibilityMeta(value?: string | null): PromptVisibilityMeta {
  return PROMPT_VISIBILITY_META[resolvePromptVisibility(value)];
}

export function visibilityShortDescription(value?: string | null, itemLabel = 'prompt'): string {
  const meta = promptVisibilityMeta(value);
  return meta.shortDescription
    .replace(/\bthis screening prompt\b/gi, `this ${itemLabel}`)
    .replace(/\bthis prompt\b/gi, `this ${itemLabel}`);
}

export function visibilityTooltipForItem(value?: string | null, itemLabel = 'prompt'): string {
  const meta = promptVisibilityMeta(value);
  return meta.tooltip
    .replace(/\bscreening prompt\b/gi, itemLabel)
    .replace(/\bthis screening prompt\b/gi, `this ${itemLabel}`)
    .replace(/\bthis prompt\b/gi, `this ${itemLabel}`);
}

export function resolveProjectVisibility(project?: {
  visibility?: string | null;
  isHiddenOnPublic?: boolean;
  is_hidden_on_public?: boolean;
}): PromptVisibility {
  if (project?.visibility) {
    return resolvePromptVisibility(project.visibility);
  }
  if (project?.isHiddenOnPublic ?? project?.is_hidden_on_public) {
    return 'recruiter_only';
  }
  return 'public';
}
